var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9B9B9B",
  fillRule: "evenodd",
  d: "M0 2.5A2.5 2.5 0 0 1 2.5 0H12a2.5 2.5 0 0 1 2.5 2.5V9a2.5 2.5 0 0 1-2.5 2.5H8.207l-2.032 2.032a.8.8 0 0 1-1.308-.269L4.16 11.5H2.5A2.5 2.5 0 0 1 0 9zM2.5 1A1.5 1.5 0 0 0 1 2.5V9a1.5 1.5 0 0 0 1.5 1.5h1.797a.8.8 0 0 1 .743.503l.643 1.607 1.876-1.876a.8.8 0 0 1 .565-.234H12A1.5 1.5 0 0 0 13.5 9V2.5A1.5 1.5 0 0 0 12 1zm8 3.5H4v-1h6.5zm-2 3H4v-1h4.5z",
  clipRule: "evenodd"
})));
export { SvgReview as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvcmV2aWV3LmRjMWRmMGI1LnN2ZyI7";